import _Checkbox from "./Checkbox";
import _Input from "./Input";
import _Radio from "./Radio";
import _TextArea from "./TextArea";
import _Password from "./Password";
import _Email from "./Email";
import _FirstName from "./FirstName";
import _LastName from "./LastName";
import _Phone from "./Phone";
import _PostalCode from "./PostalCode";

export const Form = {
  Input: _Input,
  TextArea: _TextArea,
  Checkbox: _Checkbox,
  Radio: _Radio,
  Password: _Password,
  Email: _Email,
  FirstName: _FirstName,
  LastName: _LastName,
  Phone: _Phone,
  PostalCode: _PostalCode,
};

export {
  _Input as Input,
  _TextArea as TextArea,
  _Checkbox as Checkbox,
  _Radio as Radio,
  _Password as Password,
  _Email as Email,
  _FirstName as FirstName,
  _LastName as LastName,
  _Phone as Phone,
  _PostalCode as PostalCode,
};

export * from "./PhoneInput";
export * from "./PostalCodeInput";
export * from "./MakeInput";
export * from "./ModelInput";
export * from "./TrimInput";
export * from "./YearInput";
export * from "./NumberInput";
